import React from "react";
import Plus from "../svg/Plus.jsx";
import { Link } from "react-router-dom";
import DotSvg from "../svg/DotSvg";

export default function SelectionCard({ txt, description, link, dotimgclss, indicator }) {
  return (
    <Link
      className="p-4 py-3 flex w-full justify-between items-center border border-opacity-40 border-gray-700 hover:border-[#FF2300] hover:border-opacity-100 rounded-md mb-3 transition-colors duration-200 group"
      to={link}
    >
      <div className="flex flex-col">
        <div className="flex items-center">
          <span className="text-white">{txt}</span>
          {dotimgclss && (
            <DotSvg width={6} height={6} color={"red"} className="ml-2" />
          )}
          {indicator}
        </div>
        {description && (
          <span className="text-gray-400 mt-1">{description}</span>
        )}
      </div>
      <Plus className="h-[12px] w-[12px] cursor-pointer" />
    </Link>
  );
}
